import axios from 'axios';

const BASE = '/api/intelligence/customer-database';

export const customerDatabaseApi = {
  getStats: () =>
    axios.get(`${BASE}/stats`).then((r) => r.data),

  search: (params = {}) =>
    axios.get(BASE, { params }).then((r) => r.data),

  getProfile: (contactId) =>
    axios.get(`${BASE}/${contactId}`).then((r) => r.data),

  rebuildProfile: (contactId) =>
    axios.post(`${BASE}/${contactId}/rebuild`).then((r) => r.data),
};
